import type { Game } from '@/data/games'
import { useLanguage } from '@/localization'

/**
 * Compact, icon-based card for an upcoming game shown in the "On the horizon"
 * row. No photo needed — keeps the long coming-soon list clean and scalable.
 */
export default function ComingSoonCard({ game }: { game: Game }) {
  const { t } = useLanguage()
  const Icon = game.icon

  return (
    <div className="group flex flex-col items-center gap-2 rounded-xl border border-stone-line bg-white/70 px-4 py-6 text-center shadow-card transition-all duration-200 hover:-translate-y-0.5 hover:border-uliunai-red/30 hover:shadow-card-hover">
      {Icon && (
        <span className="mb-1 inline-flex h-11 w-11 items-center justify-center rounded-lg bg-parchment-deep text-stone-400 transition-colors group-hover:text-uliunai-red">
          <Icon size={22} />
        </span>
      )}
      <span className="font-orbitron text-sm font-bold leading-tight text-stone-800">
        {game.name}
      </span>
      <span className="font-rajdhani text-xs text-stone-500">{t(game.tagline)}</span>
      <span className="mt-1 font-rajdhani text-[10px] font-semibold uppercase tracking-[0.2em] text-stone-400">
        {t('COMING SOON')}
      </span>
    </div>
  )
}
